import { Add } from "@carbon/icons-react";
import { type Table, type TableMeta } from "@tanstack/react-table";
import { type FC, useCallback } from "react";

import { Button } from "../Button";
import { emptyRow } from "./useColumnState";

export interface AddRowButtonProps {
	table: Table<unknown>;
	insertRow?: TableMeta<unknown>["insertRow"];
}

export const AddRowButton: FC<AddRowButtonProps> = ({ table, insertRow }) => {
	const handleClick = useCallback(() => {
		const newRow = emptyRow(table);
		insertRow?.(table.getRowCount(), newRow);
	}, [insertRow, table]);

	if (!insertRow) {
		return null;
	}

	return (
		<div className="flex">
			<Button
				variant="normal"
				level="tertiary"
				icon={Add}
				fullWidth
				className="!focus:ring-4 -mx-px !justify-start !rounded-none !rounded-b-md !px-2 !py-2.5 transition-none focus:outline-1 focus:-outline-offset-1 focus:outline-brand"
				onClick={handleClick}
			>
				<div className="invisible group-hover:visible text-tertiary">Add new row</div>
			</Button>
		</div>
	);
};
